export default "__VITE_ASSET__BrMPbuOn__"